export enum PaymentIdentificationType {
  BIC_BEI = 'BIC_BEI',
  DATE_PLACE_OF_BIRTH = 'DATE_PLACE_OF_BIRTH',
  OTHER = 'OTHER'
}
